var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncluded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1179 33.0539H8.03276C9.88053 31.7526 11.0917 29.6022 11.0917 27.1739V19.9871H17.0597C17.4206 19.9871 17.7128 19.6949 17.7128 19.3339C17.7128 18.9726 17.4206 18.6806 17.0597 18.6806H11.0917V11.4937C11.0917 7.5312 14.3151 4.30686 18.2785 4.30686C22.2408 4.30686 25.4654 7.53097 25.4654 11.4937C25.4654 11.8546 25.7576 12.1471 26.1185 12.1471C26.4799 12.1471 26.7719 11.8547 26.7719 11.4937C26.7719 6.81091 22.9616 3 18.2782 3C13.5954 3 9.78447 6.81028 9.78447 11.4937V18.6806H3.99247C3.63153 18.6806 3.3391 18.9728 3.3391 19.3339C3.3391 19.6949 3.63129 19.9871 3.99247 19.9871H9.78447V27.1739C9.78447 30.4161 7.14699 33.0539 3.90447 33.0539C3.54353 33.0539 3.2511 33.3461 3.2511 33.7071C3.2511 34.0685 3.54329 34.3604 3.90447 34.3604H26.1176C26.479 34.3604 26.771 34.0683 26.771 33.7071C26.771 33.3464 26.4791 33.0539 26.1179 33.0539Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.70715,
    y: 2.23032,
    width: 43,
    height: 3,
    transform: "rotate(45 3.70715 2.23032)",
    fill: "#FF0505",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncluded);
export default __webpack_public_path__ + "static/media/included.980498975cb18c2f1910c05fa0472de3.svg";
export { ForwardRef as ReactComponent };